import React from 'react';

import { AppBar, Box, Container, Toolbar, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import Copyright from './component/copyright';
import ColorModeToggle from './component/color_mode_toggle';

const SignedOutLayout = ({ children }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={ cx(classes.root) }>
            <AppBar position="absolute" elevation={ 1 }>
                <Toolbar className={ cx(classes.toolbar) }>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={ cx(classes.title) }
                                sx={ { fontWeight: 700 } }>
                        Store Web Panel
                    </Typography>
                    <ColorModeToggle/>
                </Toolbar>
            </AppBar>

            <main className={ cx(classes.content) }>
                <div className={ cx(classes.appBarSpacer) }/>
                <Container maxWidth="sm" className={ cx(classes.container) }>
                    { children }
                    <Box pt={ 4 }>
                        <Copyright/>
                    </Box>
                </Container>
            </main>
        </div>
    );
};

const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    toolbar: {
        paddingRight: 24,
    },
    title: {
        flexGrow: 1,
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    container: {
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1
    },
}));

export default SignedOutLayout;